export const NEW_CARS_DATADOG_EVENTS = {
  CONFIGURATOR_IMAGE_FALLBACK: 'configurator-image-fallback'
};
